<template>
<div>
  <b-card no-body>
    <b-tabs card>
      <b-tab title="Verzendkosten" active>
        <shipping-cost-tab></shipping-cost-tab>
      </b-tab>
      <b-tab title="Commisies">
        <commission-tab></commission-tab>
      </b-tab>
      <b-tab title="Order meldingen" active>
        <order-notification-tab></order-notification-tab>
      </b-tab>
      <b-tab title="Merk levertijden" active>
        <brand-delivery-time-tab></brand-delivery-time-tab>
      </b-tab>
      <b-tab title="Amazon xml" active>
        <amazon-xml-upload-tab></amazon-xml-upload-tab>
      </b-tab>
    </b-tabs>
  </b-card>
</div>
</template>

<script>
import ShippingCostTab from './ShippingCostTab.vue'
import CommissionTab from './CommissionTab.vue'
import OrderNotificationTab from './OrderNotificationTab.vue'
import BrandDeliveryTimeTab from './BrandDeliveryTimeTab.vue'
import AmazonXmlUploadTab from './AmazonXmlUploadTab.vue'

export default {
  components: {ShippingCostTab, CommissionTab, OrderNotificationTab, BrandDeliveryTimeTab, AmazonXmlUploadTab}
}
</script>



// WEBPACK FOOTER //
// SettingsPage.vue?078cfebd